<template>
    <div class="qa-container">
        <div class="child-label">
            <div class="text">答题问卷</div>
            <div class="tips">（选填）</div>
        </div>
        <div class="qa-list">
            <div class="qa" v-for="(qa, idx) in usedQaItems" :key="'qa-' + idx">
                <div class="qa-title">{{ qa.title }}</div>
                <div class="del-box" @click="delQa(qa)">
                    <img src="/assets/images/video/task-icon3.png" alt="">
                </div>
            </div>
            <div class="qa-btn-box">
                <div class="add" @click="showSelector">
                    <img src="/assets/images/video/task-icon2.png" alt="">
                    <span>选择问卷</span>
                </div>
            </div>
        </div>
        
        <a-modal v-model="showQaModal" class="custom-modal" width="848px" :footer="null">
            <div class="qa-selector-container">
                <a-spin :spinning="loading">
                    <div>
                        <div class="qa-selector-title">答题问卷</div>
                        <div class="qa-selector-content">
                            <table class="qa-selector-table">
                                <thead>
                                <tr>
                                    <th class="qa-select">
                                        <span @click="selectAll" class="qa-selector-btn"
                                              :class="{selected:isSelectAll()}"></span>
                                    </th>
                                    <th class="no">序号</th>
                                    <th class="create-at">问卷创建时间</th>
                                    <th class="qa-title">问卷标题</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(qa, idx) in listResult.data" :key="'qa-' + idx">
                                    <td class="qa-select">
                                        <span @click="selectQa(qa)" class="qa-selector-btn"
                                              :class="{selected:isSelect(qa)}"></span>
                                    </td>
                                    <td class="no">{{ pageNo(idx) }}
                                    </td>
                                    <td class="create-at">{{ $formatTime(qa.created_at) }}</td>
                                    <td class="qa-title">{{ qa.title }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        
                        <div class="qa-select-foot">
                            <a-pagination
                                :total="listResult.total"
                                :page-size="listResult.per_page"
                                :current-page="listResult.current_page"
                                v-model="listResult.current_page"
                                @change="fetchQaList"
                            ></a-pagination>
                            <div>
                                <button class="btn create-btn" @click="refreshQaList">刷新问卷列表</button>
                                <button class="btn create-btn" @click="gotoQa">新增问卷</button>
                                <button class="btn" @click="confirm">确定</button>
                            </div>
                        </div>
                    </div>
                </a-spin>
            </div>
        </a-modal>
    
    </div>
</template>

<script>
import api from "@/repo/api";

export default {
    name: "VideoAddQa",
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        value: {
            type: Array,
            default: () => []
        },
    },
    watch: {
        value: {
            handler() {
                this.initSelect()
                this.initUseQas()
            },
            immediate: true
        }
    },
    data() {
        return {
            showQaModal: false,
            loading: false,
            listResult: {
                // laravel pagination
                current_page: 1,
                last_page: 1,
                per_page: 10,
                total: 0,
                data: []
            },
            selectIds: [],
            allQaList: [],
            usedQaItems: [],
        }
    },
    mounted() {
        this.fetchQaList()
    },
    methods: {
        initSelect() {
            this.selectIds = JSON.parse(JSON.stringify(this.value || []))
        },
        async initUseQas() {
            
            if ((!this.selectIds) || this.selectIds.length === 0) {
                this.usedQaItems = []
                this.allQaList = [];
                return
            }
            
            const res = await api.get('/ast-qa/qa-by-ids', {
                ids: this.selectIds
            })
            
            this.usedQaItems = res.data
            
            this.allQaList = [...this.usedQaItems, ...this.allQaList.filter(item => this.usedQaItems.findIndex(qa => qa.id === item.id) === -1)]
        },
        showSelector() {
            this.initSelect()
            this.showQaModal = true
        },
        pageNo(idx) {
            return (this.listResult.current_page - 1) * this.listResult.per_page + idx + 1
        },
        refreshQaList(){
            this.fetchQaList()
        },
        gotoQa() {
            window.open('/ast/qas/create', '_blank')
        },
        confirm() {
            this.usedQaItems = this.allQaList.filter(item => this.selectIds.indexOf(item.id) !== -1)
            this.showQaModal = false
            
            this.$emit('change', this.selectIds)
        },
        async fetchQaList() {
            
            this.loading = true
            
            const res = await api.get('/ast-qa/list', {
                page: this.listResult.current_page,
                enabled: 1,
                page_size: 6
            })
            
            this.loading = false
            
            this.listResult.current_page = res.data.current_page
            this.listResult.last_page = +res.data.last_page
            this.listResult.per_page = +res.data.per_page
            this.listResult.total = +res.data.total
            this.listResult.data = res.data.data
            
            // 按id查找,不存在的合并所有问卷列表
            this.allQaList = [...this.listResult.data, ...this.allQaList.filter(item => this.listResult.data.findIndex(qa => qa.id === item.id) === -1)]
        },
        isSelect(qa) {
            return this.selectIds.indexOf(qa.id) !== -1
        },
        delQa(qa) {
            let idx = this.selectIds.indexOf(qa.id)
            if (idx !== -1) {
                this.selectIds.splice(idx, 1)
            }
            
            let idx2 = this.usedQaItems.indexOf(qa)
            if (idx2 !== -1) {
                this.usedQaItems.splice(idx2, 1)
            }
            
            this.confirm()
        },
        selectQa(qa) {
            let idx = this.selectIds.indexOf(qa.id)
            if (idx === -1) {
                this.selectIds.push(qa.id)
            } else {
                this.selectIds.splice(idx, 1)
            }
        },
        selectAll() {
            // 是否已经选择了全部
            const isSelectedAll = this.isSelectAll()
            
            for (const item of this.listResult.data) {
                
                let idx = this.selectIds.indexOf(item.id);
                
                if (idx === -1) {
                    if (isSelectedAll) continue;
                    this.selectIds.push(item.id)
                } else {
                    if (!isSelectedAll) continue;
                    this.selectIds.splice(idx, 1)
                }
            }
        },
        isSelectAll() {
            for (const item of this.listResult.data) {
                if (this.selectIds.indexOf(item.id) === -1) {
                    return false
                }
            }
            return true
        }
    }
}
</script>

<style lang="scss" scoped>
.qa-container {
    display: flex;
}

.qa-btn-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    .add {
        width: 100px;
        height: 28px;
        background: #F7F7F7;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 16px;
        cursor: pointer;
        
        img {
            width: 16px;
            height: 16px;
            margin-right: 4px;
        }
        
        span {
            color: #333;
            font-size: 12px;
        }
    }
}

.child-label {
    margin-right: 23px;
    
    .text {
        color: #333333;
    }
}

.qa-selector-container {
    width: 100%;
    height: 516px;
    background: #FFFFFF;
}

.qa-selector-title {
    height: 60px;
    padding: 24px 24px 15px;
    border-bottom: 1px solid #EEEEEE;
    
    font-weight: 500;
    font-size: 16px;
    color: #333333;
}

.qa-selector-table {
    width: 100%;
    
    th {
        height: 48px;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
    }
    
    
    td {
        height: 56px;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        line-height: 16px;
    }
    
    th, td {
        padding-left: 24px;
        padding-right: 24px;
        text-align: center;
        border: 1px solid #D9D9D9;
        
        &:first-child {
            border-left: 0;
        }
        
        &:last-child {
            border-right: 0;
        }
    }
    
    .text-left {
        text-align: left;
    }
    
    .qa-select {
        width: 64px;
        vertical-align: middle;
    }
    
    .no {
        width: 92px;
    }
    
    .create-at {
        width: 186px;
    }
    
    .qa-title {
        text-align: left;
    }
    
    .qa-selector-btn {
        margin-top: 5px;
        width: 16px;
        height: 16px;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #D9D9D9;
        display: inline-block;
        cursor: pointer;
        
        &.selected {
            background-image: url("/assets/icons/icon-active-teacher.png");
            background-size: contain;
        }
    }
}

.qa-selector-content {
    height: 385px;
}

.qa-select-foot {
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 24px;
    padding-right: 24px;
}

.create-btn {
    margin-right: 16px;
    border: 1px solid #EEEEEE;
    background-color: #FFFFFF;
    color: #999999;
}

.qa-list {
    flex: 1;
}

.qa {
    background-image: url("/assets/icons/qa-tags.png");
    background-size: auto 48px;
    background-repeat: no-repeat;
    position: relative;
    
    border: 1px solid #EEEEEE;
    width: 100%;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    margin-bottom: 16px;
    
    .qa-title {
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        line-height: 16px;
    }
    
    .del-box {
        cursor: pointer;
        width: 48px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        
        img {
            width: 16px;
            height: 16px;
        }
    }
}

</style>